import React from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';

export default function NavBar() {
  const { user, logout } = useAuth() || {};
  const navigate = useNavigate();

  const handleLogout = async () => {
    // Call logout but don't let it redirect — we will show a toast and then navigate
    try {
      if (logout) await logout(false);
      try { toast.success('Logout successful'); } catch (e) { /* ignore */ }
    } catch (e) {
      // ignore errors from logout here but still navigate
      console.error('Logout error:', e);
    }
    navigate('/');
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top">
      <div className="container">
        <Link className="navbar-brand d-flex align-items-center gap-2" to="/">
          <span className="brand-mark">🎭</span>
          <span>
            <strong>Auditorium Hub</strong>
            <div className="small text-muted">Events • Halls • Reports</div>
          </span>
        </Link>

        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mainNavMenu" aria-controls="mainNavMenu" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="mainNavMenu">
          <ul className="navbar-nav ms-auto align-items-lg-center">
            <li className="nav-item">
              <NavLink className="nav-link" to="/events">Events</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/bookings">Bookings</NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/reports">Reports</NavLink>
            </li>

            {!user && (
              <li className="nav-item ms-lg-3 d-flex gap-2">
                <Link className="btn btn-primary btn-sm" to="/login">Sign Up/Login</Link>
              </li>
            )}

            {user && (
              <li className="nav-item dropdown ms-lg-3">
                <a className="nav-link dropdown-toggle" href="#" id="userMenu" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  {user.name || user.email}
                </a>
                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userMenu">
                  <li><Link className="dropdown-item" to="/dashboard">Dashboard</Link></li>
                  <li><Link className="dropdown-item" to="/profile">Profile</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><button className="dropdown-item" onClick={handleLogout}>Log out</button></li>
                </ul>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}
